import { render, staticRenderFns } from "./PaSuggestionPanel.vue?vue&type=template&id=325a6d04&scoped=true"
import script from "./PaSuggestionPanel.vue?vue&type=script&lang=js"
export * from "./PaSuggestionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a6d04",
  null
  
)

export default component.exports